"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewModal = void 0;
const react_1 = __importStar(require("react"));
const SocialLogin_1 = require("./SocialLogin");
const renewModal_1 = require("../utils/renewModal");
const icons_1 = require("@food/ui/build/dist/src/icons");
const Modal2_1 = require("@food/ui/build/dist/src/Modal2");
const css_manager_1 = require("@food/css-manager");
const tracking_1 = require("@food/tracking");
const misc_1 = require("../utils/misc");
const auth_1 = require("../logic/auth");
const track_1 = require("../utils/track");
const react_ga_1 = require("react-ga");
const modalCloseIcon = (0, css_manager_1.registerClass)((t) => `
	z-index: ${t.zIndexes.P5_TopModal};
	position: absolute;
	top: ${t.ratios.s}em;
	right: ${t.ratios.s}em;
	color: ${t.colors.ink};
	text-decoration: none;
`);
class RenewModal extends react_1.Component {
    constructor(props) {
        super(props);
        this.open = (openArgs) => {
            // avviso analytics che la modale si e' aperta
            (0, react_ga_1.event)({
                category: 'User',
                action: 'Open sign in popup',
            });
            (0, tracking_1.track)({
                ...track_1.authTrackOverride,
                action: { type: 'auth_modal_toggle', open: true },
            });
            if (this.state.open === false) {
                this.setState({ open: true, openArgs });
            }
            // il catch vuoto serve per sovrascrivere l'handler di default di js, il quale restituisce un errore
            // che verrebbe poi segnalato a sentry, inutilmente
            if (this.loginPromise === null) {
                this.loginPromise = new Promise((resolve, reject) => (this.fakeDeferred = { resolve, reject }));
                this.loginPromise.catch(() => { });
            }
            return this.loginPromise;
        };
        // questo metodo contiene una buona parte delle bad practices possibili con React
        this.close = () => {
            const { onClose } = this.props;
            const { openArgs } = this.state;
            const wasUpdate = !!(openArgs?.upgradeRole || openArgs?.instantUpgradeRole);
            (0, tracking_1.track)({
                ...track_1.authTrackOverride,
                action: { type: 'auth_modal_toggle', open: false },
            });
            if (onClose) {
                onClose(wasUpdate);
            }
            this.setState({ open: false });
        };
        // questo metodo viene usato quando si clicca la "x" in modali di accesso o di rinnovo
        this.failedCloseHandler = () => {
            if (this.loginPromise) {
                const error = new Error('Renew chiuso / errato');
                (0, tracking_1.track)({
                    ...track_1.authTrackOverride,
                    type: 'auth_aborted',
                });
                this.fakeDeferred?.reject(error);
            }
            this.loginPromise = null;
            if ((0, misc_1.isRenew)()) {
                (0, auth_1.logout)();
            }
            this.close();
        };
        // questo metodo invece serve, al contrario di quello precedente, nel caso di chiusure quando si propone
        // un upgrade ai consumer
        this.upgradeCloseHandler = () => {
            this.close();
        };
        this.successfulLoginHandler = () => {
            this.fakeDeferred?.resolve(true);
            this.loginPromise = null;
            this.close();
        };
        const { t } = props;
        this.state = { open: false };
        this.loginPromise = null;
        this.SocialLogin = (0, SocialLogin_1.socialLoginFactory)(t);
        (0, renewModal_1.setRenewModal)(this);
    }
    render() {
        const { open, openArgs = {} } = this.state;
        const { config, authManager, logo, tokens } = this.props;
        const { fixedSocial, customComponent, upgradeRole, instantUpgradeRole, redirectOnLogin, startTraditional, } = openArgs;
        const closer = openArgs.upgradeRole || openArgs.instantUpgradeRole
            ? this.upgradeCloseHandler
            : this.failedCloseHandler;
        return (react_1.default.createElement(Modal2_1.Modal, { open: open }, ({ layout }) => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: "javascript:void(0)", onClick: closer },
                react_1.default.createElement("span", { className: modalCloseIcon },
                    react_1.default.createElement(icons_1.Icon, { name: 'close' }))),
            react_1.default.createElement(this.SocialLogin, { authManager: authManager, onSuccess: this.successfulLoginHandler, onClose: closer, tokens: tokens, isModal: true, config: config, logo: logo || config.LOGO, layout: layout === Modal2_1.ModalLayouts.Compact
                    ? SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.COMPACT
                    : SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD, 
                // parametri relativi alla singola apertura della modal
                fixedSocial: fixedSocial, customComponent: customComponent, upgradeRole: upgradeRole, instantUpgradeRole: instantUpgradeRole, forcedRenewAuthType: (0, auth_1.getLoginType)(), startTraditional: startTraditional, redirectOnLogin: redirectOnLogin })))));
    }
}
exports.RenewModal = RenewModal;
//# sourceMappingURL=RenewModal.js.map